import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { tagRemoved, tagSelected } from "../../features/filter/filterSlice";

const Tag = ({ title }) => {
  const dispatch = useDispatch();
  const { tags } = useSelector((state) => state.filter);
  const indexOfTag = tags.indexOf(title);
  const style = indexOfTag !== -1 ? "bg-blue-600 text-white" : "bg-blue-100 text-blue-600";

  const handleSelect = () => {
    if (indexOfTag === -1) {
      dispatch(tagSelected(title));
    } else {
      dispatch(tagRemoved(title));
    }
  };
  return (
    <div onClick={handleSelect} className={`${style} px-4 py-1 rounded-full cursor-pointer`}>
      {title}
    </div>
  );
};

export default Tag;
